import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'changed-profile-popup',
  templateUrl: './changed-profile-popup.component.html',
  styleUrls: ['./changed-profile-popup.component.less', '../../shared/common.less']
})
export class ChangedProfilePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Input() contactUpdated = null;
  @Input() newProfile: number = -1;
  @Input() oldProfile: number = -1;

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  defineRole(profile: number): string {
    switch (profile) {
      case 0:
        return "RH";
      case 1:
        return "BV";
      case 2:
        return "SC";
      case 3:
        return "CP";
      default:
        return "";
    }
  }

  getRoleBackgroundColor(profile: number): string {
    switch (profile) {
      case 0:
        return "#D8E8FF";
      case 1:
        return "#CBFFD5";
      case 2:
        return "#E8EDF3";
      case 3:
        return "#FDE7F3";
      default:
        return "#FFFFFF";
    }
  }

  defineFullRole(profile: number): string {
    switch (profile) {
      case 0:
        return "Ressources humaines";
      case 1:
        return "Bureau de vote";
      case 2:
        return "Scrutateur";
      case 3:
        return "Chef de projet";
      default:
        return "";
    }
  }

  ngOnInit() {
    console.log(this.contactUpdated); 
  }
}
